import CustomerMessages from './CustomerMessages';

export default CustomerMessages;
